module.exports = __webpack_public_path__ + "img/LCD_colorbar_pattern.f967a359.jpg";